export const ACTION_TYPES = {
  ALLOW: 'allow',
  DROP: 'drop',
};

export const ACTION_TYPES_OPTIONS = [
  { value: ACTION_TYPES.ALLOW, label: 'Allow' },
  { value: ACTION_TYPES.DROP, label: 'Drop' },
];
